import React from "react";
import { Modal, Button } from "react-bootstrap";
import { FaWifi } from "react-icons/fa";
import noInternet from "../../../no-internet.png";

const InternetModal = ({ show, setShow }) => {
  const handleRetry = () => {
    if (navigator.onLine) {
      setShow(false); // ✅ Close modal if online
    } else {
      alert("Still offline. Please check your internet connection.");
    }
  };

  return (
    <Modal show={show} backdrop="static" keyboard={false} className="packageModal">
      <Modal.Header closeButton={false}>
        <Modal.Title className="fw-bold">No Internet Connection</Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center">
        <div className="modal-content-wrapper">
          {noInternet && (
            <img
              src={noInternet}
              alt="No Internet"
              className="modal-image mb-3"
              style={{
                width: "180px",
                height: "180px",
                objectFit: "contain",
                marginBottom: "1rem",
              }}
            />
          )}
          <p className="message text-muted">
            You are currently offline. <br />
            Please connect to the internet to continue using the system.
          </p>
        </div>
        <div className="d-flex justify-content-center">
          <Button
            onClick={handleRetry}
            style={{
              backgroundColor: "#f2652d",
              borderColor: "#f2652d",
              borderRadius: "8px",
              fontWeight: "500",
              padding: "10px 20px",
            }}
            className="mt-4 d-flex align-items-center"
          >
            <FaWifi className="me-2" />
            Retry Connection
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default InternetModal;
